import { createRoot } from "react-dom/client"
import { useState, useEffect } from "react"
import { BrowserRouter, Routes, Route } from "react-router"
import { App } from "./App"
import "./styles.css"
import Dashboard from "./pages/Dashboard"
import LoginPage from "./pages/LoginPage"
import OrderForm from "./pages/OrderForm"

const API_BASE_URL = "http://localhost:8001/api"

const API_ENDPOINTS = {
  login: `${API_BASE_URL}/auth/login`,
  createOrder: `${API_BASE_URL}/orders`,
  getOrders: `${API_BASE_URL}/orders`,
  updateOrder: `${API_BASE_URL}/orders`,
  deleteOrder: `${API_BASE_URL}/orders`,
  bulkUpdateOrders: `${API_BASE_URL}/orders/bulk-update`,
  addOrderNote: `${API_BASE_URL}/orders/note`,
}

const PanelDashboard = () => {
  const [currentView, setCurrentView] = useState("order") // "order", "login", "dashboard"
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false)

  useEffect(() => {
    const storedLoginStatus = localStorage.getItem("isAdminLoggedIn")
    if (storedLoginStatus === "true") {
      setIsAdminLoggedIn(true)
      setCurrentView("dashboard")
    }
  }, [])

  const handleLogin = () => {
    setIsAdminLoggedIn(true)
    setCurrentView("dashboard")
  }

  const handleLogout = () => {
    localStorage.removeItem("isAdminLoggedIn")
    localStorage.removeItem("adminToken")
    setIsAdminLoggedIn(false)
    setCurrentView("order")
  }

  const navigateToAdmin = () => {
    if (isAdminLoggedIn) {
      setCurrentView("dashboard")
    } else {
      setCurrentView("login")
    }
  }

  const navigateToOrder = () => {
    setCurrentView("order")
  }

  if (currentView === "order") {
    return (
      <div>
        <nav
          style={{
            background: "#007bff",
            padding: "1rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h2 style={{ color: "white", margin: 0 }}>Kitchen Orders</h2>
          <button
            onClick={navigateToAdmin}
            style={{
              background: "white",
              color: "#007bff",
              border: "none",
              padding: "0.5rem 1rem",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Admin Panel
          </button>
        </nav>
        <OrderForm apiEndpoints={API_ENDPOINTS} />
      </div>
    )
  }

  if (currentView === "login") {
    return <LoginPage onLogin={handleLogin} apiEndpoints={API_ENDPOINTS} />
  }

  if (currentView === "dashboard") {
    return <Dashboard onLogout={handleLogout} apiEndpoints={API_ENDPOINTS} />
  }

  return null
}

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/dashboard" element={<PanelDashboard />} />
      <Route path="/order" element={<OrderForm />} />
    </Routes>
  </BrowserRouter>,
)
